const STATIC_CMS_DATA_BASE_PATH = "/__cms-data";

const normalizeCmsPath = (value: string) => {
  const trimmed = value.trim();

  if (!trimmed || trimmed === "/") {
    return "/";
  }

  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return withLeadingSlash.replace(/\/+$/g, "") || "/";
};

export const getStaticCmsDataPath = (cmsPath: string) => {
  const normalizedPath = normalizeCmsPath(cmsPath);

  if (normalizedPath === "/") {
    return `${STATIC_CMS_DATA_BASE_PATH}/index.json`;
  }

  const segments = normalizedPath.split("/").filter(Boolean).map(encodeURIComponent);
  return `${STATIC_CMS_DATA_BASE_PATH}/pages/${segments.join("/")}.json`;
};
